<nz-modal
  [nzWidth]="'800px'"
  [(nzVisible)]="isNewEditVisible"
  (nzVisibleChange)="onIsNewEditVisibleChange($event)"
  [nzTitle]="isEdit ? 'Edit Objection or Question' : 'Add New Objection or Question'"
  (nzOnCancel)="onCancelClick()"
  [nzOkText]="null"
  [nzCancelText]="null"
>
  <ng-container *nzModalContent>
    <form nz-form [nzLayout]="'vertical'" [formGroup]="validateForm" (ngSubmit)="submitForm()">
      <nz-form-item>
        <nz-form-label nzRequired nzFor="title">Question</nz-form-label>
        <nz-form-control nzErrorTip="Title required.">
          <div class="horizontal">
            <input nz-input formControlName="title" id="title" [placeholder]="'Your question'" />
          </div>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label nzRequired nzFor="type">Type</nz-form-label>
        <nz-form-control nzErrorTip="Type required.">
          <nz-radio-group formControlName="type" id="type" nzButtonStyle="solid">
            <label nz-radio-button [nzValue]="ObjectionType.emotional">Soft-skills Objection</label>
            <label nz-radio-button [nzValue]="ObjectionType.fact">Facts-based Objection</label>
          </nz-radio-group>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label nzRequired nzFor="description">Answer</nz-form-label>
        <nz-form-control nzErrorTip="Objection description required.">
          <textarea
            nz-input
            formControlName="description"
            rows="5"
            id="description"
            [placeholder]="'Your answer'"
          ></textarea>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-control>
          <button nz-button [nzType]="'primary'" class="submit-button">{{ isEdit ? 'Save' : 'Create' }}</button>
        </nz-form-control>
      </nz-form-item>
    </form>
  </ng-container>
</nz-modal>
